<template>
    <div class="inner-container">
        <b-tabs ref="tabs" v-model="currentTabIndex" @activate-tab="onTabActivate">
            <b-tab title="Паспорт" active>
                <div class="actions-tab in-tab">
                    <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                                        <span class="left">
                                            <i class="icon icon-info"></i>
                                        </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                    </b-dropdown>
                </div>
                <template>
                    <d-passport-of-program
                        ref="passportComponent"
                        :currentProgramPassport="currentProgramPassport"
                        :selectedYearFromMainPage="selectedYearFromMainPage"
                        :isFromMainPage="isFromMainPage"
                        :dateFromOtherTab="sharedDate"
                        @closePassport="closePassport"
                        @dateChanged="onDateChanged"
                        @unsavedChangesChanged="onUnsavedChangesChanged"
                    />
                </template>
            </b-tab>
            <b-tab title="Целевые индикаторы">
                <div class="actions-tab in-tab">
                    <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <div class="btn-download">
                                <div>
                                            <span class="left">
                                                <i class="icon icon-info"></i>
                                            </span>
                                    <i class="icon icon-keyboard"></i>
                                </div>
                            </div>
                        </template>
                    </b-dropdown>
                </div>
                <template>
                    <d-target-indicator
                        :currentProgramPassport="currentProgramPassport"
                        :dateFromOtherTab="sharedDate"
                    />
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import DPassportOfProgram from '@/modules/development-program/PassportOfProgram.vue';
import Indicators from '@/modules/development-program/tabs/indicators/indicators';

export default {
    name: "formOfProgramModules",
    components: {
        'd-passport-of-program': DPassportOfProgram,
        'd-target-indicator': Indicators
    },
    props: {
        currentProgramPassport: {
            required: true,
            default: null
        },
        selectedYearFromMainPage: {
            type: Number,
            default: null
        },
        isFromMainPage: {
            type: Boolean,
            default: true
        }
    },
    created(){
    },
    mounted() {
    },
    data() {
        return {
            sharedDate: null,
            hasUnsavedChanges: false,
            currentTabIndex: 0,
            forcingTabChange: false
        }
    },
    methods: {
        onDateChanged(newDate) {
            this.sharedDate = newDate;
            // Remove localStorage usage as it's not supported in artifacts
            // Instead, pass the date to other components via props
        },

        onUnsavedChangesChanged(hasChanges) {
            // Don't update the flag if we're in the middle of forcing a tab change
            if (!this.forcingTabChange) {
                this.hasUnsavedChanges = hasChanges;
            }
        },

        // In your parent component, update the onTabActivate method:
        async onTabActivate(newTabIndex, prevTabIndex, bvEvent) {
            if (prevTabIndex === 0 && this.hasUnsavedChanges) {
                bvEvent.preventDefault();
                try {
                    const confirmed = await this.$bvModal.msgBoxConfirm(
                        'Внесенные изменения будут потеряны!',
                        {
                            title: 'Несохраненные изменения',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'warning',
                            okTitle: 'Продолжить',
                            cancelTitle: 'Отмена',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true
                        }
                    );
                    if (confirmed) {
                        this.forcingTabChange = true;
                        if (this.$refs.passportComponent) {
                            await this.$refs.passportComponent.cleanupUnsavedChanges();
                        }
                        this.hasUnsavedChanges = false;

                        // Programmatically trigger the switch via v-model inside nextTick
                        this.$nextTick(() => {
                            this.currentTabIndex = newTabIndex;
                            this.forcingTabChange = false;
                        });
                    }
                } catch (error) {
                    console.error('Error showing confirmation dialog:', error);
                    this.forcingTabChange = false;
                }
            }
            // No 'else' needed: if no unsaved changes, the event proceeds naturally without prevention
        },

        closePassport(close){
            this.$emit('closePassport', close);
        },

        // Method to check for unsaved changes (can be called from outside)
        async checkUnsavedChanges() {
            if (this.hasUnsavedChanges) {
                const confirmed = await this.$bvModal.msgBoxConfirm(
                    'Внесенные изменения будут потеряны!',
                    {
                        title: 'Несохраненные изменения',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        okTitle: 'Продолжить',
                        cancelTitle: 'Отмена',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }
                );

                return confirmed;
            }
            return true;
        }
    },
    computed: {
    },

    // Handle navigation away from the entire component
    async beforeRouteLeave(to, from, next) {
        const canLeave = await this.checkUnsavedChanges();
        if (canLeave) {
            next();
        } else {
            next(false);
        }
    }
}
</script>

<style scoped>

</style>